/** Created by azhou on 2019/3/14.*/
<template>
    <div id="addStaff">
      <public-title>添加账号
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
      </public-title>
      <div class="bg-white p-4">
        <el-button
          v-if="positionLists.lists.length == 0" class="mt-3 mb-3"
          type="primary"
          @click="$router.push({name:'PositionManage'})">暂无职位，去添加</el-button>
        <div v-if="positionLists.lists.length > 0">
          <div class="d-center mb-3">
            <left-text-border leftText="手机号" type="number" class="w-50" v-model="accountInfo.mobile"/>
            <send-phone-code class="ml-3 w-50" :phoneNumber="accountInfo.mobile" url="/pc/Reglogin/GetRegCode"
              @getCode="code => this.accountInfo.sms_code = code"
              template="SMS_269225220" @showError="msg => _alert(msg,null,'error')"/>
          </div>
          <div class="d-center mb-3">
            <left-text-border leftText="姓名" class="w-50" v-model="accountInfo.truename"/>
            <div class="d-center-start ml-3 w-50">
              <left-text leftText="使用状态"/>
              <el-radio v-model="accountInfo.status" :label="'1'">启用</el-radio>
              <el-radio v-model="accountInfo.status" :label="'0'">禁用</el-radio>
            </div>
          </div>
          <div class="d-center mb-3">
            <left-text-border type="password" leftText="登录密码" class="w-50" v-model="accountInfo.pwd"/>
            <left-text-border type="password" leftText="确认密码" class="ml-3 w-50" v-model="accountInfo.pwd2"/>
          </div>
          <div class="d-center mb-3">
            <left-text leftText="选择职位"/>
            <el-radio-group v-model="accountInfo.position_id" class="w-100 text-left">
              <el-radio :disabled="disabledRadio( item.id)" :label="item.id" v-for="item in positionLists.lists" :key="item.id">{{item.name}}</el-radio>
            </el-radio-group>
          </div>
          <div class="d-start-start">
            <left-text leftText="选择门店"/>
            <div class="text-left">
              <el-tag class="mr-2 mb-2" v-for="tag in chooseStore" :key="tag.id" closable @close="closeTag(tag)">
                {{tag.title}}
              </el-tag>
            </div>
          </div>
          <el-collapse accordion class="pl-2 text-left pl-2 mt-2" @change="getStoreUser" v-model="storeId">
            <el-collapse-item v-for="(item,index) in StoreLists.lists" :key="index" :name="item.id">
              <template slot="title">
                <el-checkbox class="mr-2" v-model="item.checked" />
                <div class="w-50">{{item.title}}</div>{{item.province_name+item.city_name}}
              </template>
              <div>详细地址：{{item.address}}</div>
              <div>当前负责人：<span class="text-muted" v-show="storeUser.length<=0">未设置负责人</span>
                <span class="text-info mr-1" v-for="v in storeUser" :key="v.id">{{v.truename}}</span>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-button @click="addStaff" class="mt-4" type="primary">提交</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  export default {
    name: 'AddAccount',
    computed: {
      ...mapState(['StoreLists','positionLists']),
      ...mapGetters(['storeInfo','isGroup']),
      chooseStore() {
        return this.StoreLists.lists.filter(v => v.checked);
      }
    },
    data() {
      return {
        accountInfo:{
          status:'1'
        },
        storeId:'',           //根据门店Id获取管理人信息
        storeUser:[],         //门店已绑定的负责人数组
      }
    },
    async created() {
      await this.getUserPositionLists();      //获取职位列表
      await this.getUserStoreLists();         //获取门店列表
      if (this.StoreLists.lists.length === 1) {
        this.UPDATESTORELISTS({lists:[{...this.StoreLists.lists[0],checked:true}]})
      }
    },
    methods:{
      ...mapMutations(['UPDATESTORELISTS']),
      ...mapActions(['getUserPositionLists','getUserStoreLists','getStoreLinkLists','addUserStaff']),
      //点击某一门店时获取该门店已添加的负责人信息
      async getStoreUser(value) {
        if (value) this.storeUser = await this.getStoreLinkLists(this.storeId);
      },
      //删除tag标签
      closeTag(item) {
        this.StoreLists.lists.forEach(v => {
          if (v.id === item.id) v.checked = false;
        });
      },
      /*表单验证函数*/
      validateFun() {
        if (!this.accountInfo.mobile) return {code: false, msg: '请填写手机号'};
        if (!this.accountInfo.sms_code) return {code: false, msg: '请输入验证码'};
        if (!this.accountInfo.truename) return {code: false, msg: '请输入姓名'};
        if (!this.accountInfo.pwd || !this.accountInfo.pwd2) return {code: false, msg: '密码不得为空'};
        if (this.accountInfo.pwd !== this.accountInfo.pwd2) return {code: false, msg: '两次密码不一致'};
        if (!this.accountInfo.position_id) return {code: false, msg: '请选择职位'};
        if (this.chooseStore.length <= 0) return {code: false, msg: '请选择该人员管理的门店'};
        return {code: true, msg: '表单验证通过'}
      },
      //添加账号
      addStaff() {
        let result = this.validateFun();
        if (result.code) {
          this._confirm('确定提交么？',() => {
            this.addUserStaff({
              ...this.accountInfo,
              store_ids:this.chooseStore.map(item => item.id),
            })
          })
        } else this._alert(result.msg,null,'error');
      },
      //判断选择职位不可选
      disabledRadio(id){
      let n=false;
        switch (this.storeInfo.type) {
          case 2:
          if(!this.isGroup){
            if(id==1||id==6){n=true}
          }else{
            if(id==6){n=true}
          }
          break;
          case 3:
            if(!this.isGroup){
              if(id==3||id==7){n=true}
            }else{
              if(id==7){n=true}
            }
          break;
          default:return '';
        }
        return n
      }
    }
  }
</script>
<style lang="scss">
  .get-code{
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .d-center input{
    width: 80% !important;
  }
    .d-center .el-input{
    width: 80% !important;
  }
  .d-center .el-input input{
    width: 100% !important;
  }
</style>
